import React, { Component } from 'react';
import { connect } from 'react-redux'
import App from "./Admin/App";
import './Login-Form-Dark.css';
import TeacherApp from './Teacher/TeacherApp';
import StudentApp from './Student/StudentApp';
import ParentApp from './Parent/ParentApp';
import productImg from './assets/img/product-icon.png';
class Login extends Component {


    loginHandler = (event) => {
        event.preventDefault();
        var username = document.getElementById('username').value;
        var pwd = document.getElementById('pwd').value;
        if (username === "DRAStick" && pwd === "123456") {
            console.log("success");
            this.props.login();
        }else if (username === "Teacher" && pwd === "123456") {
            console.log("success");
            this.props.teacherLogin();
        }else if (username === "Student" && pwd === "123456") {
            console.log("success");
            this.props.studentLogin();
        }
        else if (username === "Parent" && pwd === "123456") {
            console.log("success");
            this.props.parentLogin();
        } else {
            console.log("failed")
        }
    }

    render() {
        let loginScreen = (
            <div className="login-dark">
                <form onSubmit={this.loginHandler} method="POST">
                    <h2 className="sr-only">Login Form</h2>
                    <div className="illustration"><img src={productImg} width="150px" /></div>
                    {/* <div className="illustration"><i className="fa fa-lock"></i></div> */}
                    <div className="form-group"><input className="form-control" type="text" name="email" placeholder="Email" id="username" /></div>
                    <div className="form-group"><input className="form-control" type="password" name="password" placeholder="Password" id="pwd" />
                    </div>
                    <div className="form-group"><button className="btn btn-primary btn-block" >Log In</button></div>
                    <a href="https://drastick.in" className="forgot">Forgot your email or password?</a>
                </form>
            </div>)

        return !this.props.isUserLoggedIn ? loginScreen : this.props.userType==="Admin"?<App />:this.props.userType==="Teacher"?<TeacherApp />:this.props.userType==="Student"?<StudentApp />:this.props.userType==="Parent"?<ParentApp />:<h1>You are Unauthorized Persion</h1>;
    }
}
const mapStateToProps = state => {
    return {
        isUserLoggedIn: state.isAuthenticated,
        userType:state.userType,
    };
}
const mapDispatchToProps = dispatch => {
    return {
        login: () => dispatch({ type: 'Login' }),
        teacherLogin: () => dispatch({ type: 'TeacherLogin' }),
        studentLogin: () => dispatch({ type: 'StudentLogin' }),
        parentLogin: () => dispatch({ type: 'ParentLogin' }),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Login);